// settings/workflow/helper/workflowConfigSchema.js

import * as Yup from "yup";

export const workflowConfigSchema = Yup.object({
  workflowName: Yup.string().trim().required("Workflow name is required"),
  entityName: Yup.string().trim().required("Entity name is required"),

  steps: Yup.array()
    .of(
      Yup.object({
        stepName: Yup.string().trim().required("Step name is required"),
        roleId: Yup.string().trim().required("Role is required"),

        // onRejectAction: Yup.string().nullable(),
        // onRejectGoToSequence: Yup.number()
        //   .nullable()
        //   .when("onRejectAction", {
        //     is: (v) => v === "gotostep",
        //     then: (s) => s.typeError("Select a valid step").required("Select the step to go to on reject"),
        //     otherwise: (s) => s.nullable(),
        //   }),

        childSteps: Yup.array().of(
          Yup.object({
            childStepName: Yup.string().trim().required("Child step name is required"),
            roleId: Yup.string().trim().required("Child step role is required"),
            allowParallelExecution: Yup.boolean(),
            minimumApprovalCount: Yup.number()
              .nullable()
              .when("allowParallelExecution", {
                is: true,
                then: (s) =>
                  s.typeError("Minimum approvals must be a number")
                    .required("Minimum approvals is required when parallel execution is enabled")
                    .min(1, "Minimum approvals must be at least 1"),
                otherwise: (s) => s.nullable(),
              }),
          })
        ),
      })
    )
    .min(1, "Add at least one step"),
});
